import theme from '../adminTheme';

/**
 * Paginación reutilizable: anterior / siguiente + texto opcional.
 */
const AdminPagination = ({
  page,
  totalPages,
  total,
  pageSize,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  label = 'elementos' // ej. "clubs", "afiliaciones"
}) => {
  const from = total === 0 ? 0 : (page - 1) * (pageSize || 10) + 1;
  const to = Math.min(page * (pageSize || 10), total);

  return (
    <div style={theme.pagination}>
      <span style={theme.paginationInfo}>
        Mostrando {from}-{to} de {total} {label}
        {totalPages > 1 && ` (Página ${page} de ${totalPages})`}
      </span>
      <div style={theme.paginationButtons}>
        <button
          type="button"
          style={hasPrev ? theme.btnPagination : theme.btnPaginationDisabled}
          onClick={onPrev}
          disabled={!hasPrev}
          aria-label="Página anterior"
        >
          ← Anterior
        </button>
        <button
          type="button"
          style={hasNext ? theme.btnPagination : theme.btnPaginationDisabled}
          onClick={onNext}
          disabled={!hasNext}
          aria-label="Página siguiente"
        >
          Siguiente →
        </button>
      </div>
    </div>
  );
};

export default AdminPagination;
